import { render, staticRenderFns } from "./DeviceDetailView.vue?vue&type=template&id=5d0cf9f0&"
import script from "./DeviceDetailView.vue?vue&type=script&lang=ts&"
export * from "./DeviceDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports